export default {
  en(text){
    return encodeURIComponent(text)
  },
  de(text){
    return decodeURIComponent(text)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/url.js